export type DocumentType = "passport" | "national_id" | "driver_license";

export interface SelfieCapture {
  imageDataUrl: string;
  capturedAt: string;
}

export interface UploadedFile {
  name: string;
  size: number;
  type: string;
  dataUrl: string;
}

export interface DocumentUpload {
  documentType: DocumentType;
  frontImage: UploadedFile;
  backImage?: UploadedFile;
}

export interface KycFormData {
  selfie: SelfieCapture | null;
  document: DocumentUpload | null;
}

export type KycStepId = "selfie" | "document";

export interface KycStepDefinition {
  id: KycStepId;
  label: string;
  description: string;
}

export const ACCEPTED_MIME = ["image/jpeg", "image/png", "image/webp", "application/pdf"];
export const MAX_FILE_BYTES = 8 * 1024 * 1024;

export function dataUrlToFile(dataUrl: string, fileName: string): File {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/jpeg";
  const bstr = atob(arr[1]);
  const u8arr = new Uint8Array(bstr.length);
  for (let i = 0; i < bstr.length; i += 1) {
    u8arr[i] = bstr.charCodeAt(i);
  }
  return new File([u8arr], fileName, { type: mime });
}

export function base64ByteSize(dataUrl: string): number {
  const base64 = dataUrl.split(",")[1] ?? "";
  const padding = (base64.match(/=+$/) ?? []).join("").length;
  return Math.floor((base64.length * 3) / 4) - padding;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
